<template>
  <div v-if="visible" class="credit_container" @click="bodyClosePop">
    <div class="pop_main">
      <IDelTag class="del_icon" @click.native="closeClick" />
      <div class="credit_icon">
        <img width="55px" src="./images/h5_payment_icon_ant_credit.png"
        srcset="./images/h5_payment_icon_ant_credit.png 1x, ./images/h5_payment_icon_ant_credit@2x.png 2x" >
      </div>
      <h3>目前少年得到已支持花呗支付，如无法正常完成支付，可参考以下原因：</h3>
      <div class="reason">
        <p>· 支付宝账号未开通花呗</p>
        <p>· 支付宝花呗额度不足</p>
        <p>· 支付宝花呗账号有逾期未还款项</p>
      </div>

      <div class="sure_btn" @click="closeClick">确定</div>

    </div>
  </div>
</template>

<script>
import { IDelTag } from '@/components/ITag';
export default {
  name: 'INotUseCredit',
  props: {
    visible: Boolean
  },
  methods: {
    bodyClosePop(e) {
      const popEl = document.querySelector('.pop_main');
      let self = this;
      if (self.visible == true && !popEl.contains(e.target)) {
        this.closeClick();
      }
    },
    closeClick() {
      this.$emit('closeClick');
    }
  },
  components: {
    IDelTag
  }
};
</script>

<style lang="stylus" scoped>
.credit_container {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  left: 0;
  top: 0;
  overflow hidden;
  z-index: 10

  .pop_main {
    width 295px
    padding 30px
    background #fff
    position absolute
    left 50%
    top 50%
    transform translate(-50%,-50%)
    border-radius 10px
    box-sizing border-box

    .del_icon {
      position absolute
      right 10px
      top 10px
    }

    .credit_icon {
      text-align center
      margin 20px 0 10px 0
    }

    h3 {
      font-size 16px
      line-height 24px
      color #41414D
      font-weight 500
    }

    .reason {
      margin-top 12px

      p {
        font-size 14px
        color #6D6D80
        line-height 22px
      }
    }

    .sure_btn {
      height 50px
      border-radius 25px
      background #FF5E2E
      margin-top 15px
      text-align center
      font-size 18px
      line-height 50px
      color #fff
    }
  }
}
</style>